module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'more-composes': _vm.number_composes > 1
    },
    attrs: {
      "id": "email-scheduler"
    }
  }, [_c('div', {
    staticClass: "scheduler__title"
  }, [_vm._v(_vm._s(_vm.scheduler_header))]), _c('div', {
    staticClass: "scheduler__datepicker-wrapper"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Selecione a data:")]), _c('datepicker', {
    attrs: {
      "inline": true,
      "disabled": {
        to: _vm.yesterday,
        from: _vm.from_dates
      },
      "language": "pt-br"
    },
    model: {
      value: (_vm.due_on_date),
      callback: function($$v) {
        _vm.due_on_date = $$v
      },
      expression: "due_on_date"
    }
  })], 1)]), _c('div', {
    staticClass: "form-group scheduler__default-times"
  }, [_c('label', [_vm._v("Selecione o horário:")]), _vm._l((_vm.default_times), function(time) {
    return _c('div', {
      staticClass: "scheduler__default-time",
      class: {
        selected: _vm.isSelected(time)
      },
      on: {
        "click": function($event) {
          return _vm.selectDefaultTime(time)
        }
      }
    }, [_vm._v(_vm._s(time))])
  })], 2), _c('div', {
    staticClass: "form-group time-to-send-picker-wrapper",
    class: {
      'has-error': _vm.errors.has('due_on_time')
    }
  }, [_c('label', [_vm._v("Horário customizado:")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|regex:^([0-2][0-9]:[0-5][0-9])$'),
      expression: "'required|regex:^([0-2][0-9]:[0-5][0-9])$'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##:##'),
      expression: "'##:##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.due_on_time),
      expression: "due_on_time"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "due_on_time",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": (_vm.due_on_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.due_on_time = $event.target.value
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('due_on_time')),
      expression: "errors.has('due_on_time')"
    }],
    key: "due_on_time",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('due_on_time')))])])], 1), (_vm.is_meeting_schedule) ? _c('div', {
    staticClass: "form-group time-to-send-picker-wrapper"
  }, [_c('label', [_vm._v("Lembrar convidados:")]), _c('div', [_c('span', {
    staticClass: "meeting-reminder-date"
  }, [_vm._v(_vm._s(_vm.due_on_scheduler.format('DD/MM/YYYY')) + " ")]), _vm._v("às "), _c('span', {
    staticClass: "meeting-reminder-date"
  }, [_vm._v(_vm._s(_vm.due_on_time))])])]) : _vm._e(), (_vm.is_meeting_schedule) ? _c('div', {
    staticClass: "form-group time-to-send-picker-wrapper"
  }, [_c('label', [_vm._v("Reunião marcada para:")]), _c('div', [_c('span', {
    staticClass: "meeting-date"
  }, [_vm._v(_vm._s(_vm.task.due_on.format('DD/MM/YYYY')) + " ")]), _vm._v("às "), _c('span', {
    staticClass: "meeting-date"
  }, [_vm._v(_vm._s(_vm.task.due_on.format('HH:mm')))])])]) : _vm._e(), _c('div', {
    staticClass: "scheduler__footer"
  }, [(!_vm.is_meeting_schedule) ? _c('div', {
    staticClass: "btn-primary btn-gray btn",
    on: {
      "click": function($event) {
        return _vm.closeScheduler()
      }
    }
  }, [_vm._v("Cancelar")]) : _vm._e(), (!_vm.is_meeting_schedule) ? _c('div', {
    staticClass: "btn-primary btn-save btn",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("Agendar")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-204d4240!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/compose/scheduler.vue
// module id = 1039
// module chunks = 1